/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Activity from './models/Activity';
import Rank from './models/Rank';
import GlobalStats from './models/GlobalStats';
import Achievement from './models/Achievement';
import AchievementCategory from './models/AchievementCategory';
import AchievementLevel from './models/AchievementLevel';
import UserAchievement from './models/UserAchievement';

export default {
	'gamilytics/common/models/Activity': Activity,
	'gamilytics/common/models/Rank': Rank,
	'gamilytics/common/models/GlobalStats': GlobalStats,
	'gamilytics/common/models/Achievement': Achievement,
	'gamilytics/common/models/AchievementCategory': AchievementCategory,
	'gamilytics/common/models/AchievementLevel': AchievementLevel,
	'gamilytics/common/models/UserAchievement': UserAchievement,
};
